import { render, staticRenderFns } from "./AccountSettingLimitTable.vue?vue&type=template&id=d5108808&scoped=true&"
import script from "./AccountSettingLimitTable.vue?vue&type=script&lang=js&"
export * from "./AccountSettingLimitTable.vue?vue&type=script&lang=js&"
import style0 from "./AccountSettingLimitTable.vue?vue&type=style&index=0&id=d5108808&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5108808",
  null
  
)

export default component.exports